import {convertToEstDate} from "Services/TimeZonesUtils";
import React from "react";
import PropTypes from "prop-types";
import {getAuditStatusBackgroundColor} from "../../../Styles/Audits.styles";

export const AuditTitle = ({audit}) => {
    return <>
        <span
            className="float-end fw-bold"
            style={{
                backgroundColor: getAuditStatusBackgroundColor(audit.audit_status.id),
                padding: "4px 8px",
                borderRadius: "4px",
            }}
        >
            {audit.active ? audit.audit_status.name : "(Archived) " + audit.audit_status.name}
        </span>
        <h1 className="mb-2 headline-sm">
            Inspection: {audit.name}
        </h1>
        <h6 className="subTitle subtitle-sm">
            <strong> Created by </strong> {audit.created_by} <strong> On </strong>
            {convertToEstDate(audit.created_at)}. <span />
            <strong> Last updated by </strong> {audit.modified_by} <strong> On </strong>
            {convertToEstDate(audit.updated_at)}.
        </h6>
    </>;
};

AuditTitle.propTypes = {
    audit: PropTypes.object.isRequired,
};
